import mapValues from 'lodash/mapValues';
import { MessagesInterface, UserAccessRight } from '../../../general/model';

export type PermissionModalShape = {
  targetNodeID: number | null;
  permissions: Record<UserAccessRight, boolean>;
  isLoading: boolean;
  isApplying: boolean;
  selectedUsers: number[];
};

export const initialState: PermissionModalShape = {
  targetNodeID: null,
  permissions: mapValues(UserAccessRight, (v) => UserAccessRight.read === v),
  isLoading: true,
  isApplying: false,
  selectedUsers: [],
};
export const Messages: MessagesInterface = {
  loadUsersError: () => ({
    title: `Server request error`,
    message: `Failed to load users`,
  }),
  applyPermissionsError: (users: string[] = []) => ({
    title: `Failed to apply permissions to users`,
    message: `${users.join('; ')}`,
  }),
  settingPermissions: () => ({
    title: 'Setting permissions...',
    message: 'It can take some time',
    position: 'tc',
  }),
};
